var map = {
	"./account_role_template.svg": "bc17",
	"./business_creation.svg": "9287",
	"./company.svg": "23c3",
	"./country.svg": "317e",
	"./region.svg": "3606",
	"./role_type.svg": "2f4e",
	"./roles.svg": "1c02",
	"./snapshots.svg": "2fd7",
	"./tag.svg": "9770",
	"./users.svg": "1847",
	"./users_management.svg": "ed37"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "abd0";